export default "__VITE_ASSET__Bf0QClI3__"